import { useCallback, useEffect, useRef } from 'react';

import { rawTrackEngagementEvent } from '../../services/tracking/pulse';

export const useBylineTracking = (title?: string) => {
  const trackingStateRef = useRef<'idle' | 'viewed' | 'clicked'>('idle');

  useEffect(() => {
    trackingStateRef.current = 'idle';
  }, [title]);

  const trackBylineView = useCallback(() => {
    if (trackingStateRef.current === 'idle') {
      rawTrackEngagementEvent({
        intent: 'View',
        object: {
          name: title,
          type: 'UIElement',
          id: 'byline',
          elementType: 'Byline',
        },
      });

      trackingStateRef.current = 'viewed';
    }
  }, [title]);

  const trackBylineClick = useCallback(() => {
    if (trackingStateRef.current === 'viewed') {
      rawTrackEngagementEvent({
        intent: 'Contact',
        action: 'Click',
        object: {
          name: title,
          type: 'UIElement',
          id: 'byline',
          elementType: 'Byline',
        },
      });

      trackingStateRef.current = 'clicked';
    }
  }, [title]);

  return {
    trackBylineView,
    trackBylineClick,
  };
};
